/* * @Author: chenxf1@pingpongx.com  * @Date: 2019-10-28 19:54:10  * @Last Modified by:   chenxf  * @Last Modified time: 2019-10-28 19:54:10  */
import * as userApi from './modules/user'
import * as webSiteApi from './modules/webSiteApi'
import * as commonApi from './modules/common'
import * as recordApi from './modules/record'
import * as settlement from './modules/settlement'
import * as certification from './modules/certification'
import * as riskApi from './modules/riskTranscation'

export default {
	/** -----------  user api -------------- */

	// 用户登录
	getLoginInfo: userApi.getLoginInfo,
	// 用户登出
	getLogoutInfo: userApi.getLogoutInfo,
	// new: addTempAccount
	addTempAccount: userApi.addTempAccount,
	// 用户注册
	userRegister: userApi.userRegister,
	// 用户注册->发送短信验证码
	registerSendMsg: userApi.registerSendMsg,
	// 重置密码
	resetPwd: userApi.resetPwd,
	// 初次登陆->发送短信验证码
	loginSendMsg: userApi.loginSendMsg,
	// 初次登陆设置密码
	loginSetPwd: userApi.loginSetPwd,
	// 账号中心
	accountCenter: userApi.accountCenter,
	// 校验手机号码是否可用
	emailCheck: userApi.emailCheck,
	// 重置密码--发送验证码
	resetPwdSendMsg: userApi.resetPwdSendMsg,
	// 用户中心数据获取
	getAccountCenterInfo: userApi.getAccountCenterInfo,
	// 获取geetest极验初始化配置
	getGeeTestParams: userApi.getGeeTestParams,
	// geetest极验二次验证
	getGeeTestValidate: userApi.getGeeTestValidate,
	// 收益账户验证--发送验证码
	beneficiarySendMsg: userApi.beneficiarySendMsg,
	// 添加收益账号
	addbeneficiary: userApi.addbeneficiary,
	// 修改收益账号
	updatebeneficiary: userApi.updatebeneficiary,
	// 查询处于打款中的结算记录
	getInProcessList: userApi.getInProcessList,
	// 获取支持的内地银行卡列表
	getBankList: userApi.getBankList,
	// 获取省
	getProvinceList: userApi.getProvinceList,
	// 获取市
	getCityList: userApi.getCityList,
	// 超级登录
	overLocker: userApi.overLocker,

	/** -----------  website api -------------- */
	// 获取网站总揽信息
	getWebSiteOverview: webSiteApi.getWebSiteOverview,
	// 获取网站列表
	getWebListInfo: webSiteApi.getWebListInfo,
	// 获取网站列表
	getStoreSelectOne: webSiteApi.getStoreSelectOne,
	// 获取交易记录列表
	getShopDetail: webSiteApi.getShopDetail,
	// 获取交易记录列表导出url
	getTradeExportURL: webSiteApi.getTradeExportURL,
	// 获取待入账金额列表
	getPreInboundData: webSiteApi.getPreInboundData,
	// 获取待入账金额url
	getPreInboundExportURL: webSiteApi.getPreInboundExportURL,
	// 获取保证金明细
	getDepositData: webSiteApi.getDepositData,
	// 获取保证金明细导出
	getDepositExportURL: webSiteApi.getDepositExportURL,
	// 网站管理 账户余额
	getAccountBalance: webSiteApi.getAccountBalance,
	// 交易记录详情
	getTradeDetail: webSiteApi.getTradeDetail,
	// 取消交易
	cancleTrade: webSiteApi.cancleTrade,
	// 预授权交易
	confirmTrade: webSiteApi.confirmTrade,
	// 退款
	returnTrade: webSiteApi.returnTrade,
	arrowRefund: webSiteApi.arrowRefund,
	getArrowRefund: webSiteApi.getArrowRefund,
	// 提现记录
	getWithdrawRacdList: webSiteApi.getWithdrawRacdList,
	// 提现记录导出
	getWithdrawRacdExportURL: webSiteApi.getWithdrawRacdExportURL,
	// 获取提现网站
	getWithdrawWebsite: webSiteApi.getWithdrawWebsite,
	// 查看今日打款
	getTodayWithdraw: webSiteApi.getTodayWithdraw,
	// 提现
	doWithdraw: webSiteApi.doWithdraw,
	// 获取交易状态和类型
	getFundStatus: webSiteApi.getFundStatus,
	// 查询商户属性
	getClientProperty: webSiteApi.getClientProperty,

	getXManPayBank: webSiteApi.getXManPayBank,

	getKBanKPayBank: webSiteApi.getKBanKPayBank,
	// 保存商户属性
	// saveClientProperty: webSiteApi.saveClientProperty,
	// 获取风险订单列表
	getRiskTranscationList: riskApi.getRiskTranscationList,

	/** ------------ 打款记录 api ----------------- */
	// 查询打款记录列表
	loadWithdrawList: recordApi.loadWithdrawList,
	//  获取打款网站
	getWithdrawStoreList: recordApi.getWithdrawStoreList,
	// 查询提现记录
	loadSelfWithdrawList: recordApi.loadSelfWithdrawList,

	/** ------------ 数据上报 api ----------------- */
	// 查询打款记录列表
	// getDataReportSelectData: dataReportApi.getDataReportSelectData,
	//  获取打款网站
	// getDataReportStoreList: dataReportApi.getDataReportStoreList,
	// 查询提现记录
	// getAccountBalance: dataReportApi.getAccountBalance,

	/** ------------ 结算报表 api settlement ----------------- */
	selectSettlementData: settlement.selectSettlementData,
	getStoreList: settlement.getStoreList,
	exportExcel: settlement.exportExcel,
	/** ------------ 个人认证 api certification ----------------- */
	uploadFile: certification.uploadFile,
	downloadFile: certification.downloadFile,
	personal: certification.personal,
	company: certification.company,
	query: certification.query,
	getWriter: certification.getWriter,
	deleteFile: certification.deleteFile,
	/** ------------ common  模块 api ----------------- */
	//  大数据埋点
	buriedPoint: commonApi.buriedPoint
}
